import ReactDOM from 'react-dom';
import * as React from 'react';
import { store } from './ifixit_store';
import { Provider } from 'react-redux';
import { withErrorInfo } from './logging.ts';

const getPlaceholders = name => {
   return document.querySelectorAll(`.react-component[data-name="${name}"]`);
};

/**
 * This will mount React component `Component` in placeholder divs that have
 * a data-name of `name`.
 *
 * This is used by the ReactComponent.php class to indicate mount points.
 */
const initializeComponent = (name, Component, defaultProps) => {
   onDomReady(function () {
      var placeholders = getPlaceholders(name);

      Array.convert(placeholders).forEach(placeholder => {
         console.time(name);
         var props = {
            ...defaultProps,
            ...JSON.parse(placeholder.getAttribute('data-props')),
         };

         withErrorInfo(
            () =>
               ReactDOM.render(
                  <Provider store={store}>
                     <Component {...props} />
                  </Provider>,
                  placeholder
               ),
            console_error =>
               console_error('Error occurred while rendering', Component, 'with props', props)
         );
         console.timeEnd(name);
      });
   });
};

/** Reexport our Redux store, because some components expect it defined here */
export { store };

export default initializeComponent;
